var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cropzoomimg-container",
      style: { height: _vm.properHeight },
      attrs: { "aspect-ratio": _vm.aspectRatio },
      on: {
        mouseover: function ($event) {
          _vm.renderVideoIcon = false
        },
        mouseleave: function ($event) {
          _vm.renderVideoIcon = _vm.initialRender
        },
      },
    },
    [
      _vm.isDvids
        ? _c("dvidsVideo", {
            attrs: {
              slideId: _vm.slide.slideId,
              videoObj: _vm.videoObj,
              portalId: _vm.portalId,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isYouTube
        ? _c("youTubeVideo", {
            attrs: { slideId: _vm.slide.slideId, videoId: _vm.videoId },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isVideo
        ? _c(
            "hoverOverlayLink",
            {
              attrs: {
                title: _vm.overlaytitle,
                data: _vm.data,
                href: _vm.slideLink,
                showOverlay: _vm.clickCallback ? true : false,
                clickCallback: _vm.handleClick,
                iconRender: _vm.renderOverlayClassIcons,
              },
            },
            [
              _vm.data && _vm.data.isVideo && !_vm.slide
                ? _c("i", {
                    staticClass: "video-image-overlay fa-brands fa-youtube",
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.useOverlay
                ? _c("div", { staticClass: "video-overlay" })
                : _vm._e(),
              _vm._v(" "),
              _c("img", {
                ref: "mainImage",
                staticClass: "cropzoomimg-img",
                class: _vm.imgClasses,
                attrs: {
                  alt: "",
                  actualAspectRatio: _vm.imgAspectRatio,
                  src: _vm.src,
                },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }